import moment from "moment";
import { orderBy } from "natural-orderby";
import { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import ReactTooltip from "react-tooltip";

import { GET, newFetch } from "../../helpers/fetch";

import { useTranslation } from "react-i18next";
import { config } from "../../config";
import PageShell, { EmptyState } from "../../components/UI/PageShell";
const { SERVER_URL } = config;

const EDocs = ({ history }) => {
  const { t } = useTranslation();
  const user = JSON.parse(localStorage.getItem("user"));
  const clientID =
    user.site_associates.length > 0
      ? user.site_associates[0].site.client_id
      : null;

  const [client, setClient] = useState(null);

  const fetchClient = async (id) => {
    let api_path = `/client/${id}`;
    let response = await newFetch(GET, api_path);
    if (response.success) {
      setClient(response.data);
    }
  };

  useEffect(() => {
    if (clientID) {
      fetchClient(clientID);
    }
  }, [clientID]);

  const sortOptions = [
    "Title A-Z",
    "Title Z-A",
    "Latest to Oldest",
    "Oldest to Latest",
  ];
  const [eDocs, setEDocs] = useState([]);
  const [sortedEDocs, setSortedEDocs] = useState([]);
  const [activeSort, setActiveSort] = useState("Title A-Z");

  useEffect(() => {
    if (client) setEDocs(client.edocs);
  }, [client]);

  const sortDocs = (data, option) => {
    let clone = JSON.parse(JSON.stringify([...data]));

    switch (option) {
      case "Title A-Z":
        clone = orderBy(clone, [(edoc) => edoc.title], ["asc"]);
        break;

      case "Title Z-A":
        clone = orderBy(clone, [(edoc) => edoc.title], ["desc"]);
        break;

      case "Latest to Oldest":
        clone = clone.sort(
          (a, b) => moment(b.createdAt).unix() - moment(a.createdAt).unix()
        );
        break;

      case "Oldest to Latest":
        clone = clone.sort(
          (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix()
        );
        break;

      default:
        break;
    }

    return clone;
  };

  useEffect(() => {
    setSortedEDocs(sortDocs(eDocs, activeSort));
  }, [activeSort, eDocs]);
  return (
    <PageShell
      title={t("eDocs")}
      eyebrow="Document library"
      description="Find and open documents shared with your workplace."
    >
      <div className="portal-content-card">
        <div className="portal-toolbar">
          <label htmlFor="sortDoc">{t("Sort documents")}</label>
          <select
            className="form-select"
            name="sortDoc"
            id="sortDoc"
            value={activeSort}
            onChange={({ target: { value } }) => setActiveSort(value)}
          >
            {sortOptions.map((opt, i) => (
              <option key={`sortOpt-${i}`} value={opt}>
                {t(opt)}
              </option>
            ))}
          </select>
        </div>
        <div className="portal-list">
        {sortedEDocs.map((doc) => (
          <div
            key={doc.id}
            className="portal-list-item"
          >
            <span className="portal-settings-card__icon" aria-hidden="true">
              <i className="fas fa-file-alt" />
            </span>
            <div className="flex-grow-1">
              <div
                className="font-weight-bold mb-1"
                role="button"
                tabIndex="0"
                onClick={() =>
                  window.open(`${SERVER_URL}/${doc.file}`, "_blank")
                }
                onKeyDown={(event) => {
                  if (event.key === "Enter") window.open(`${SERVER_URL}/${doc.file}`, "_blank");
                }}
              >
                {doc.title}
              </div>
              <div className="text-muted" style={{ fontSize: "0.8rem" }}>
                {"Uploaded " + moment(doc.createdAt).format("DD MMMM YYYY")}
              </div>
            </div>
            <div className="mx-2" style={{ minWidth: "16px" }}>
              <i
                className="fas fa-info-circle text-brand"
                data-tip
                data-for={`desc-${doc.id}`}
              ></i>
              <ReactTooltip id={`desc-${doc.id}`}>
                <span>{doc.description}</span>
              </ReactTooltip>
            </div>
          </div>
        ))}
        {!sortedEDocs.length && (
          <EmptyState
            icon="fa-file-alt"
            title="No documents yet"
            description="Documents shared by your organization will appear here."
          />
        )}
        </div>
      </div>
    </PageShell>
  );
};

export default withRouter(EDocs);
